import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import Intelligence from "@/components/sections/Intelligence";
import Features from "@/components/sections/Features";
import FeatureSpotlight from "@/components/sections/FeatureSpotlight";
import HowItWorks from "@/components/sections/HowItWorks";
import Showcase from "@/components/sections/Showcase";
import DashboardPreview from "@/components/sections/DashboardPreview";
import WhyFacetra from "@/components/sections/WhyFacetra";
import Testimonials from "@/components/sections/Testimonials";
import Pricing from "@/components/sections/Pricing";
import Waitlist from "@/components/sections/Waitlist";
import StyleHub from "@/components/sections/StyleHub";
import Footer from "@/components/sections/Footer";
import OrganizationSchema from "@/components/OrganizationSchema";
import SEOHead from "@/components/SEOHead";

export default function Landing() {
  return (
    <div className="bg-[#0B0B0B] min-h-screen">
      <SEOHead
        title="Facetra — AI Jewellery Design Studio for Kundan, Jadau, Polki, Diamond & Temple"
        description="Facetra is the AI-powered jewellery design platform for Kundan, Jadau, Polki, Diamond, Temple and Meenakari ateliers. Turn sketches into photoreal renders, multi-view sheets, live-rate BOM and CAD-ready 3D meshes — same day."
        canonical="https://facetra.studio/"
        keywords="AI jewellery design tool, AI Kundan jewellery, AI Jadau jewellery, AI Polki diamond, AI diamond jewellery design, AI temple jewellery, AI Meenakari, Indian jewellery software, sketch to CAD jewellery, jewellery render AI, Rajwadi jewellery AI"
      />
      <OrganizationSchema />
      <Navbar />
      <main>
        <Hero />
        <Intelligence />
        <Features />
        <FeatureSpotlight />
        <HowItWorks />
        <Showcase />
        <DashboardPreview />
        <StyleHub />
        <WhyFacetra />
        {/* "Words from the floor" testimonials hidden per product
            decision (2026-06-09). Component kept around to flip back on
            once we have real designer quotes to feature. */}
        {false && <Testimonials />}
        <Pricing />
        <Waitlist />
      </main>
      <Footer />
    </div>
  );
}
